var map = {
	"./cds/2.jpg": "5812",
	"./ofresh/2.jpg": "44d9",
	"./tq/2.jpg": "4d82",
	"./yhnc/2.jpg": "c725",
	"./ys/2.jpg": "4478"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f75b";